module.exports = __webpack_public_path__ + "media/images/slider-340be7f156078c57776a496b18c6c023.svg";